import { useQuery } from '@tanstack/react-query'
import {
  GETMarketplacePreviewStores,
  MarketplacePreviewStoresParams,
} from '../requests'
import { MARKETPLACE_PREVIEW_QUERY_KEYS } from './keys'

export const useMarketplacePreviewStores = (
  params: MarketplacePreviewStoresParams
) => {
  return useQuery({
    queryFn: () => GETMarketplacePreviewStores(params),
    queryKey: [MARKETPLACE_PREVIEW_QUERY_KEYS.stores(params)],
  })
}
